// Every layout, by id (ids are unique across jobs; the booking layouts serve
// free slots and a single free slot alike). Which job has which lives with
// the jobs in data/postTypes.js; this is only the drawing.
import reviews from './reviews'
import services from './services'
import team from './team'
import info from './info'
import booking from './booking'
import transformations from './transformations'

export const LAYOUTS = { ...reviews, ...services, ...team, ...info, ...booking, ...transformations }
